import { Localized } from "@fluent/react";
import { DocumentStatus } from "../documents/documentsApi";

export const DocumentStatusLabel = ({ status }: { status: DocumentStatus }) => {
    switch (status) {
        case "N":
            return <Localized id="document-status-n">
                <span>_Nowy</span>
            </Localized>
        case "I":
            return <Localized id="document-status-i">
                <span>_Do zatwierdzenia</span>
            </Localized>
        case "K":
            return <Localized id="document-status-k">
                <span>_Korekta</span>
            </Localized>
        case "A":
            return <Localized id="document-status-a">
                <span>_Zatwierdzony</span>
            </Localized>
        case "F":
            return <Localized id="document-status-f">
                <span>_Zakończony</span>
            </Localized>
        case "P":
            return <Localized id="document-status-p">
                <span>_Opublikowany</span>
            </Localized>
        case "O":
            return <Localized id="document-status-o">
                <span>_Opiniowanie</span>
            </Localized>
        case "D":
            return <Localized id="document-status-d">
                <span>_Zaopiniowany</span>
            </Localized>
        case "E":
            return <Localized id="document-status-e">
                <span>_Zaimportowany</span>
            </Localized>
        case "R":
            return <Localized id="document-status-r">
                <span>_Odrzucony</span>
            </Localized>
        case "X":
            return <Localized id="document-status-x">
                <span>_importowanie</span>
            </Localized>
        case "B":
            return <Localized id="document-status-b">
                <span>_ready to publish</span>
            </Localized>
        case "C":
            return <Localized id="document-status-c">
                <span>_cancelled</span>
            </Localized>
        case "H":
            return <Localized id="document-status-h">
                <span>_on hold</span>
            </Localized>
        case "W":
            return <Localized id="document-status-w">
                <span>_approved with warning</span>
            </Localized>
        case "ID":
            return <Localized id="document-status-id">
                <span>_in discussion</span>
            </Localized>
        default:
            return <span>{status}</span>
    }
}